/**
 * DataBest — post-login landing route helper.
 * Caregivers land on /today (operational view).
 * Everyone else lands on /dashboard.
 */
export const landingPathForRole = (role) =>
    role === "caregiver" ? "/today" : "/dashboard";
